import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';

export interface GiftToneResponse extends APIResponse
{

}

export class GiftToneResponseDtoImpl extends APIResponseDtoImpl implements GiftToneResponse
{
   
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/tune/gifttune/gifttoneresponse.tsx